module.exports = __webpack_public_path__ + "static/media/CTLI_14-178w.96b6ef72.png";